<template>
  <div id="reset-wrapper">
    <div v-if="!token" class="message">
      <h1>{{ $t("onboard.passReset.header1") }}</h1>
      <p>{{ $t('onboard.passReset.text1') }}</p>
    </div>

    <form
      v-if="token"
      id="reset"
      @submit="resetPass"
      action="#"
      method="post"
      novalidate="true"
    >
      <h1>{{ $t("onboard.passReset.header2") }}</h1>
      <p>{{ $t('onboard.passReset.text2') }}</p>

      <label for="pass" class="required">{{
        $t("onboard.passReset.password")
      }}</label>
      <span v-if="errPasswordReuse" class="error">
        {{ $t("onboard.passReset.errorMsg.lastestPw") }}
      </span>
      <span v-if="errPasswordStrength" class="error">
        {{ $t("onboard.passReset.errorMsg.invalidPw") }}
      </span>
      <input
        type="password"
        id="pass"
        name="pass"
        v-bind:class="{
          error: errPassword || errPasswordStrength || errPasswordReuse,
        }"
        v-model="pass"
        v-on:input="
          errPassword = false;
          errPasswordStrength = false;
          errPasswordReuse = false;
        "
      />
      <p class="error errorMsg" v-if="errPassword">
        {{ $t("onboard.passReset.errorMsg.noPw") }}
      </p>

      <div class="center-wrapper">
        <input
          type="submit"
          class="submit"
          v-bind:value="$t('onboard.passReset.button.reset')"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { userService } from "@/services/user.service";
import { validFileInclusion } from "@/utils/validFileInclusion";

export default {
  name: "PassReset",
  data() {
    return {
      invalidForm: true,
      errPasswordReuse: false,
      errPasswordStrength: false,
      errPassword: false,
      pass: null,
      token: this.$route.query.token,
    };
  },
  methods: {
    resetPass: function(event) {
      this.invalidForm = false;
      this.errPassword = false;
      this.errPasswordStrength = false;
      this.errPasswordReuse = false;

      if (!this.pass || validFileInclusion(this.pass)) {
        this.invalidForm = true;
        this.errPassword = true;
      }

      if (!this.invalidForm) {
        userService
          .resetPassword(this.token, this.pass)
          .then((user) => {
            if (user.token) {
              localStorage.setItem("user", JSON.stringify(user));
              this.$router.push("/plans");
            }
          })
          .catch((err) => {
            if (err === "Field 'password' is not a valid password") {
              this.errPasswordStrength = true;
            } else if (
              err === "You have already used this password in the past"
            ) {
              this.errPasswordReuse = true;
            }
          });
      }

      event.preventDefault();
    },
  },
};
</script>

<style scoped lang="scss">
#reset-wrapper {
  h1,
  p {
    text-align: center;
  }
  .message {
    margin-bottom: 45px;
    padding-top: 120px;
    background: url("../../assets/icons/onboard-email.png") no-repeat center top;
  }
  form {
    padding-top: 120px;
    background: url("../../assets/icons/onboard-password.png") no-repeat center
      top;
  }
  .center-wrapper {
    margin-top: 40px;
    text-align: center;
    input {
      margin: 0;
    }
  }
}
.errorMsg {
  margin-top: -20px;
  text-align: start !important;
}
</style>
